export const DEEPLINKS = {
  PRINT_PLANS: '/print_plans',
  ACCOUNT_DETAILS_MANAGE_USERS: '/account-details/manage-users'
};
